module.exports = __webpack_public_path__ + "img/plus-small.36142e7b.svg";